import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-34d02e74"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "row" };
const _hoisted_2 = {
    key: 0,
    class: "col-12 px-sm-3 pb-md-45 pb-2 px-0"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "h2-responsive mt-4 text-center mb-3" }, "Unsere Auszeichnungen", -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = { class: "carousel__item" };
const _hoisted_7 = ["href", "title"];
const _hoisted_8 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Slide = _resolveComponent("Slide");
    const _component_Pagination = _resolveComponent("Pagination");
    const _component_Carousel = _resolveComponent("Carousel");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.noHeadline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Carousel, {
                breakpoints: _ctx.breakpoints,
                autoplay: 4000,
                "wrap-around": true
            }, {
                addons: _withCtx(() => [
                    (_ctx.isMobile)
                        ? (_openBlock(), _createBlock(_component_Pagination, { key: 0 }))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logos, (logo, index) => {
                        return (_openBlock(), _createBlock(_component_Slide, { key: index }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("a", {
                                        href: logo.link,
                                        title: logo.title,
                                        rel: "nofollow noopener noreferrer",
                                        target: "_blank"
                                    }, [
                                        _createElementVNode("img", {
                                            src: _ctx.optimizeImage(logo.path, 300),
                                            alt: logo.alt,
                                            class: "p-2",
                                            style: { "height": "180px", "width": "100%", "object-fit": "contain" }
                                        }, null, 8, _hoisted_8)
                                    ], 8, _hoisted_7)
                                ])
                            ]),
                            _: 2
                        }, 1024));
                    }), 128))
                ]),
                _: 1
            }, 8, ["breakpoints"])
        ])
    ]));
}
